import fileDownload from "js-file-download";
import ApiDefault from "../../ApiDefault";

export default function ToolsApi() {
    const apiDefault = ApiDefault("v2/system/tools");

    const replace = async (data) => {
        return await apiDefault.api
            .post(`/${apiDefault.url}/replace-ocurrences`, data)
            .then((response) => {
                return {
                    status: response.status === 200,
                    data: response.data.data,
                    info: response.data.info,
                };
            })
            .catch((error) => {
                return {
                    status: false,
                    message: error.response.data.message,
                };
            });
    };

    const anyFiles = async (source, files, fileName, data) => {
        let url = `/${apiDefault.url}/any-files/${source}`;

        if (data && Object.keys(data)) {
            url += `?${Object.keys(data)
                .map((field) => `${field}=${data[field]}`)
                .join("&")}`;
        }

        return await apiDefault.api
            .post(url, files, {                
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                fileDownload(response.data, fileName);

                return {
                    status: response.status === 200,
                    data: [],
                };
            })
            .catch((error) => {
                return {
                    status: false,
                    message: error.response.data.message,
                };
            });
    };

    return {
        anyFiles,
        replace,
    };
}
